import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "a6-12 c8-12 f6-6 mb-64"
}
const _hoisted_2 = { class: "flex flex--gap-large flex--align-center mb-32" }
const _hoisted_3 = { class: "notification-settings" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("tr", { class: "notification-settings__header" }, [
  /*#__PURE__*/_createElementVNode("th", { align: "start" }, " Project "),
  /*#__PURE__*/_createElementVNode("th", { align: "end" }, " Emails ")
], -1 /* HOISTED */)
const _hoisted_5 = { align: "start" }
const _hoisted_6 = { align: "end" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _component_LightswitchComponent = _resolveComponent("LightswitchComponent")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      ($data.loading)
        ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_LightswitchComponent, {
                label: "My projects only",
                "off-label": "My projects only",
                checked: $data.my_projects_only,
                disabled: $data.loading || $data.setting_notifications,
                onChange: $options.toggleMyProjectsOnly
              }, null, 8 /* PROPS */, ["checked", "disabled", "onChange"])
            ]),
            _createElementVNode("table", _hoisted_3, [
              _hoisted_4,
              _createVNode(_TransitionGroup, {
                name: "list",
                tag: "tbody"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filtered_projects, (project) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: project.id,
                      class: "notification-settings__row"
                    }, [
                      _createElementVNode("td", _hoisted_5, _toDisplayString(project.title), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_6, [
                        _createVNode(_component_LightswitchComponent, {
                          label: "On",
                          "off-label": "Off",
                          justify: "end",
                          checked: project.emails,
                          disabled: $data.setting_notifications,
                          onChange: value => $options.toggleEmails( project.id, value )
                        }, null, 8 /* PROPS */, ["checked", "disabled", "onChange"])
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              })
            ])
          ]))
    ]),
    _: 1 /* STABLE */
  }))
}